import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { LiveSearchFilters } from './widgets/live-search-filters/LiveSearchFilters'
import { LiveSearchTypes } from './widgets/live-search-types/LiveSearchTypes'
import { LiveSearchContent } from './widgets/live-search-content/LiveSearchContent'
import { useAppDispatch, useAppSelector } from '../../app/store/hooks/Redux'
import {
  selectLiveSearchApplyFilters,
  selectLiveSearchFilters,
  setLiveSearchApplyFilters,
} from './model/liveSearchSlice'
import { useLazyGetResearchLiveQuery } from '../../app/api'
import { IBody, usePoolRequest } from '../../shared/lib/hooks/UsePoolRequest'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const LiveSearchPage = () => {
  const { t } = useTranslation()
  const applyFilters = useAppSelector(selectLiveSearchApplyFilters)
  const { keyword, ...filters } = useAppSelector(selectLiveSearchFilters)
  const dispatch = useAppDispatch()

  const [getLiveSearch, { isLoading, isFetching }] = useLazyGetResearchLiveQuery()
  const {
    start,
    data,
    isLoading: poolLoading,
    isUninitialized: poolUninitialized,
    isTimeout: poolTimeout,
  } = usePoolRequest({
    request: useLazyGetResearchLiveQuery,
    onCancel: () => {
      dispatch(setLiveSearchApplyFilters(false))
    },
  })

  useEffect(() => {
    if (keyword && applyFilters) {
      getLiveSearch({
        deviceTypeId: filters.device as number,
        countryId: filters.country as number,
        engineId: filters.searchEngine as number,
        keyword: keyword,
      }).then((response) => {
        start(response?.data as unknown as IBody | undefined)
      })
    }
  }, [applyFilters])

  return (
    <CommonMainPage title={t('navigation.liveSearch')}>
      <LiveSearchFilters />
      <LiveSearchTypes
        disable={!data?.items?.length}
        isLoading={(poolLoading && !poolTimeout) || isLoading || isFetching}
      />
      <LiveSearchContent
        data={data}
        isLoading={(poolLoading && !poolTimeout) || isLoading || isFetching}
        isUninitialized={poolUninitialized}
      />
    </CommonMainPage>
  )
}
